import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'

interface PermissionState {
  hasPermission: boolean
}

const initialState: PermissionState = {
  hasPermission: true,
}

export const permissionState = createSlice({
  name: 'permission',
  initialState,
  reducers: {
    permit: (state) => {
      state.hasPermission = true
    },
    deny: (state) => {
      state.hasPermission = false
    },
  },
})

export const { permit, deny } = permissionState.actions
export const selectHasPermission = (state: RootState) =>
  state.permission.hasPermission
export default permissionState.reducer
